export default "/assets/43b184969f4bd52fc25ddf5242d1b792.woff2";